// extracted by mini-css-extract-plugin
export var container = "_ce-0";
export var icon = "_ce-1";
export var text = "_ce-2";